import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
    static targets = ["menuList"];

    declare readonly menuListTarget: HTMLElement

    connect() {
        console.log("Menu controller connected");
    }

    activate(event: any) {
        event.preventDefault();
        // Remove active class from all links
        this.menuListTarget.querySelectorAll('.nav-link').forEach(link => {
            link.classList.remove('active');
        });
        // Add active class to the clicked link
        event.currentTarget.classList.add('active');
    }

    showFilters(event: any) {
        this.activate(event);

        const filterModal = document.getElementById('filterModal');
        if (filterModal) {
            const filterModalController = this.application.getControllerForElementAndIdentifier(filterModal, 'public--list--modal-filter') as any;
            filterModalController.open();
        }
    }
}
